import React from 'react';

import { connect } from 'react-redux';
import { fetchSubscription } from '../store/actions/subscriptionActions';
import { BACK, ENTER, UP, DOWN, RIGHT, LEFT, EXIT } from '../util/remoteButtons';
import { getMuteFlag, setMuteFlag, getLogoFlag, setLogoFlag, fireAnalytics } from '../pages/utils';
import { fetchDevice, updateDevice } from '../store/actions/deviceActions';


export class Settings extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            navBar: false,
            mute: false,
            errorPopup: false,
            open: false,
            showLogo: false
        };
        this.selectedBtn = "MuteBase";
        this.selectedBtn1 = "No";
        this.errorMessage = '';
    }

    componentWillMount() {
        if (getMuteFlag()) this.setState({ mute: getMuteFlag() });
        if (getLogoFlag()) this.setState({ showLogo: true });
    }

    async componentDidMount() {
        fireAnalytics("Page", "Settings Page Loaded");
        setTimeout(() => {
            if (getMuteFlag()) {
                document.getElementById("muteOverlay").style.display = "block";
                document.getElementById("muteBase").style.display = "none";
                document.getElementById("muteSwitch").style.left = 'auto';
                document.getElementById("muteSwitch").style.right = 0;
                this.selectedBtn = "MuteOverlay";
                this.setState({
                    mute: true
                });
            }
            if (getLogoFlag()) {
                document.getElementById("logoOverlay").style.display = "block";
                document.getElementById("logoBase").style.display = "none";
                document.getElementById("logoSwitch").style.left = 'auto';
                document.getElementById("logoSwitch").style.right = 0;
                this.setState({ showLogo: true });
                setLogoFlag(true);
            }
            if (this.props.device.data.interval <= 60000) {
                document.getElementById("intervalTime").value = Math.floor(this.props.device.data.interval / 1000);
                document.getElementById("intervalOptions").selectedIndex = 0;
            }
            else if (this.props.device.data.interval <= 3600000) {
                document.getElementById("intervalTime").value = Math.floor(this.props.device.data.interval / 60000);
                document.getElementById("intervalOptions").selectedIndex = 1;
            }
            else {
                document.getElementById("intervalTime").value = Math.floor(this.props.device.data.interval / 3600000);
                document.getElementById("intervalOptions").selectedIndex = 2;
            }
        }, 200);
        window.onkeydown = async (e) => {
            switch (e.keyCode) {
                case UP:
                    e.preventDefault();
                    // if (this.selectedBtn === 'MuteBase' || this.selectedBtn === 'MuteOverlay') {
                    // this.setState(() => ({ navBar: true }));
                    // setTimeout(() => {
                    //     const { navBar } = this.refs;
                    //     navBar.refs.topBar.focus();
                    // }, 300);
                    // } else 
                    if (this.selectedBtn === 'LogoBase' || this.selectedBtn === 'LogoOverlay') {
                        document.getElementById("muteDevice").classList.add("settingsActiveElement");
                        document.getElementById("showLogo").classList.remove("settingsActiveElement");
                        if (this.state.mute) {
                            this.selectedBtn = 'MuteOverlay';
                        } else {
                            this.selectedBtn = 'MuteBase';
                        }
                    } else if (this.selectedBtn === 'IntervalTime') {
                        var val = parseInt(document.getElementById("intervalTime").value);
                        if (val < 59) {
                            val++;
                            document.getElementById("intervalTime").value = val;
                        } else {
                            this.errorMessage = 'Value Cannot Exceed 59';
                            this.setState({ errorPopup: true });
                            setTimeout(() => {
                                this.setState({ errorPopup: false });
                            }, 3000);
                        }
                    } else if (this.selectedBtn === 'IntervalOptions') {
                        document.getElementById("intervalOptions").blur();
                        document.getElementById("showLogo").classList.add("settingsActiveElement");
                        document.getElementById("intervalOptions").classList.remove("settingsActiveElement");
                        this.selectedBtn = 'LogoBase'
                    } else if (this.selectedBtn === 'Back') {
                        document.getElementById("intervalOptions").focus();
                        document.getElementById("intervalOptions").classList.add("settingsActiveElement");
                        document.getElementById("backBtn").classList.remove("settingsActiveElement");
                        this.selectedBtn = 'IntervalOptions'
                    }
                    break;
                case 27:
                case BACK:
                    if (this.state.open) {
                        this.setState({ open: false });
                    } else {
                        this.handleBack();
                    }
                    break;
                case ENTER:
                    if (this.state.open) {
                        if (this.selectedBtn1 === 'No') {
                            this.setState({ open: false });
                            return;
                        }
                        if (this.selectedBtn1 === 'Yes') {
                            window.open("", "_self").close();
                        }
                    } else {
                        if (this.selectedBtn === 'MuteBase') {
                            this.muteDevice();
                        } else if (this.selectedBtn === 'MuteOverlay') {
                            this.unmuteDevice();
                        } else if (this.selectedBtn === 'LogoBase') {
                            this._showLogo();
                        } else if (this.selectedBtn === 'LogoOverlay') {
                            this._hideLogo();
                        } else if (this.selectedBtn === 'Back') {
                            this.handleBack();
                        }
                    }
                    break;
                case DOWN:
                    e.preventDefault();
                    if (this.selectedBtn === 'MuteBase' || this.selectedBtn === 'MuteOverlay') {
                        document.getElementById("showLogo").classList.add("settingsActiveElement");
                        document.getElementById("muteDevice").classList.remove("settingsActiveElement");
                        if (!this.state.showLogo) this.selectedBtn = 'LogoBase';
                        else this.selectedBtn = 'LogoOverlay';
                    } else if (this.selectedBtn === 'LogoBase' || this.selectedBtn === 'LogoOverlay') {
                        document.getElementById("intervalTime").classList.add("settingsActiveElement");
                        document.getElementById("showLogo").classList.remove("settingsActiveElement");
                        this.selectedBtn = 'IntervalTime'
                    } else if (this.selectedBtn === 'IntervalTime') {
                        var val = parseInt(document.getElementById("intervalTime").value);
                        if (val > 0) {
                            val--;
                            document.getElementById("intervalTime").value = val;
                        } else {
                            this.errorMessage = 'Value Cannot be Less Than 0';
                            this.setState({ errorPopup: true });
                            setTimeout(() => {
                                this.setState({ errorPopup: false });
                            }, 3000);
                        }
                    } else if (this.selectedBtn === 'IntervalOptions') {
                        document.getElementById("intervalOptions").blur();
                        document.getElementById("backBtn").classList.add("settingsActiveElement");
                        document.getElementById("intervalOptions").classList.remove("settingsActiveElement");
                        this.selectedBtn = 'Back'
                    }
                    break;
                case RIGHT:
                    e.preventDefault();
                    if (this.state.open) {
                        document.getElementById('No').style.background = '';
                        document.getElementById('yes').style.background = '#910048';
                        this.refs.yes.focus();
                        this.selectedBtn1 = 'Yes';
                    } else {
                        if (this.selectedBtn === 'IntervalTime') {
                            document.getElementById("intervalOptions").focus();
                            document.getElementById("intervalOptions").classList.add("settingsActiveElement");
                            document.getElementById("intervalTime").classList.remove("settingsActiveElement");
                            this.selectedBtn = 'IntervalOptions'
                        }
                    }
                    break;
                case LEFT:
                    e.preventDefault();
                    if (this.state.open) {
                        document.getElementById('yes').style.background = '';
                        document.getElementById('No').style.background = '#910048';
                        this.refs.no.focus();
                        this.selectedBtn1 = 'No';
                    } else {
                        if (this.selectedBtn === 'IntervalOptions') {
                            document.getElementById("intervalOptions").blur();
                            document.getElementById("intervalTime").classList.add("settingsActiveElement");
                            document.getElementById("intervalOptions").classList.remove("settingsActiveElement");
                            this.selectedBtn = 'IntervalTime'
                        }
                    }
                    break;
                case EXIT:
                    if (this.state.open) {
                        this.setState({ open: false });
                    } else {
                        this.setState({ open: !this.state.open });
                        this.selectedBtn1 = 'No';
                    }
                    break;
                default:
                    console.log("Key Not Handled");
                    break;
            }
        };
    }

    async handleBack() {
        let selectedOption = document.getElementById("intervalOptions").value;
        let interval;
        if (selectedOption === 'seconds') {
            interval = (parseInt(document.getElementById("intervalTime").value)) * 1000;
        } else if (selectedOption === 'minutes') {
            interval = (parseInt(document.getElementById("intervalTime").value)) * 60000;
        } else if (selectedOption === 'hours') {
            interval = (parseInt(document.getElementById("intervalTime").value)) * 3600000;
        }
        if (interval !== this.props.device.data.interval) {
            const response = await this.props.updateDevice(this.props.device.data.id, "interval", interval);
            if (response.success) {
                this.errorMessage = 'Settings Updated Successfully';
                this.setState({ errorPopup: true });
                const fetch = await this.props.fetchDevice(this.props.app.webosDeviceId);
                setTimeout(() => {
                    this.setState({ errorPopup: false });
                    this.props.history.goBack();
                }, 3000);
            } else {
                this.errorMessage = 'Unable to Save Settings';
                this.setState({ errorPopup: true });
                await this.props.fetchDevice(this.props.app.webosDeviceId);
                setTimeout(() => {
                    this.setState({ errorPopup: false });
                    this.props.history.goBack();
                }, 3000);
            }
        } else {
            this.errorMessage = 'Settings updated successfully';
            this.setState({ errorPopup: true });
            setTimeout(() => {
                this.setState({ errorPopup: false });
                this.props.history.goBack();
            }, 3000);
        }
    }

    async muteDevice() {
        const response = await this.props.updateDevice(this.props.device.data.id, "mute", !this.state.mute);
        if (response.success) {
            setMuteFlag(!this.state.mute);
            this.setState({
                mute: !this.state.mute
            });
            document.getElementById("muteOverlay").style.display = "block";
            document.getElementById("muteBase").style.display = "none";
            document.getElementById("muteSwitch").style.left = 'auto';
            document.getElementById("muteSwitch").style.right = 0;
            this.selectedBtn = 'MuteOverlay';
            await this.props.fetchDevice(this.props.app.webosDeviceId);
        }
    }

    async unmuteDevice() {
        const response = await this.props.updateDevice(this.props.device.data.id, "mute", !this.state.mute);
        if (response.success) {
            setMuteFlag(!this.state.mute);
            this.setState({
                mute: !this.state.mute
            });
            document.getElementById("muteBase").style.display = "block";
            document.getElementById("muteOverlay").style.display = "none";
            document.getElementById("muteSwitch").style.left = 0;
            document.getElementById("muteSwitch").style.right = 'auto';
            this.selectedBtn = 'MuteBase';
            await this.props.fetchDevice(this.props.app.webosDeviceId);
        }
    }

    async _showLogo() {
        document.getElementById("logoOverlay").style.display = "block";
        document.getElementById("logoBase").style.display = "none";
        document.getElementById("logoSwitch").style.left = 'auto';
        document.getElementById("logoSwitch").style.right = 0;
        this.selectedBtn = 'LogoOverlay';
        setLogoFlag(true);
    }

    async _hideLogo() {
        document.getElementById("logoBase").style.display = "block";
        document.getElementById("logoOverlay").style.display = "none";
        document.getElementById("logoSwitch").style.left = 0;
        document.getElementById("logoSwitch").style.right = 'auto';
        this.selectedBtn = 'LogoBase';
        setLogoFlag(false);
    }

    render() {
        return (
            <div className="SettingsWrapper">
                {this.state.open ? (
                    <div id="models" className="reg-response-modal" style={{ position: 'absolute', zIndex: '9999', padding: '0%' }}>
                        <div className="model" style={{ width: '40%', backgroundColor: 'black', color: 'white', borderRadius: '15px' }}>
                            <img className="logo2" src="/assets/img/blackdove-logo-2020.png" alt="" style={{ width: '50%', paddingTop: '6%' }} />
                            <h2 style={{ marginBottom: '2%' }}>Do you want to exit?</h2>
                            <button
                                ref="no"
                                id="No"
                                onClick={() => {
                                    this.setState({ open: false });
                                }}
                                style={{ background: '#910048' }}
                                className="exitPopup"
                            >No
                            </button>
                            <button
                                ref="yes"
                                id="yes"
                                style={{ marginLeft: '2%' }}
                                className="exitPopup"
                            >Yes
                            </button>
                        </div>
                    </div>
                ) : null}
                {/* {
                    this.state.navBar ? <NavBar ref="navBar" subscription={this.props.hasSubscription} onNavigation={(navTo) => this.onNavigation(navTo)} /> : null
                } */}
                <div className="leftWrapper">
                    <div className="leftWrapper_Content-Wrapper">
                        SETTINGS
                    </div>
                    <div className="leftWrapper_muteDevice-Wrapper">
                        <div className="leftWrapper_muteDevice-Wrapper_text">Mute Device</div>
                        <div id="muteDevice" className="leftWrapper_muteDevice-Wrapper_images settingsActiveElement">
                            <img id="muteBase" className="leftWrapper_muteDevice-Wrapper_images_base" src="/assets/img/base.png" alt="" onClick={() => this.muteDevice()} />
                            <img id="muteOverlay" className="leftWrapper_muteDevice-Wrapper_images_overlay" src="/assets/img/overlay.png" alt="" onClick={() => this.unmuteDevice()} />
                            <img id="muteSwitch" className="leftWrapper_muteDevice-Wrapper_images_switch" src="/assets/img/switch.png" alt="" />
                        </div>
                    </div>
                    <div className="leftWrapper_showLogo-Wrapper">
                        <div className="leftWrapper_showLogo-Wrapper_text">Show Logo</div>
                        <div id="showLogo" className="leftWrapper_showLogo-Wrapper_images">
                            <img id="logoBase" className="leftWrapper_showLogo-Wrapper_images_base" src="/assets/img/base.png" alt="" onClick={() => this._showLogo()} />
                            <img id="logoOverlay" className="leftWrapper_showLogo-Wrapper_images_overlay" src="/assets/img/overlay.png" alt="" onClick={() => this._hideLogo()} />
                            <img id="logoSwitch" className="leftWrapper_showLogo-Wrapper_images_switch" src="/assets/img/switch.png" alt="" />
                        </div>
                    </div>
                    <div className="leftWrapper_switchArtwork-Wrapper">
                        <div className="leftWrapper_switchArtwork-Wrapper_text">Switch Artwork Every</div>
                        <div className="leftWrapper_switchArtwork-Wrapper_images">
                            <input type="text" id="intervalTime" name="intervalTime" />
                            <select name="intervalOptions" id="intervalOptions">
                                <option value="seconds">Seconds</option>
                                <option value="minutes">Minutes</option>
                                <option value="hours">Hours</option>
                            </select>
                        </div>
                    </div>
                    <div className="leftWrapper_backBtn-Wrapper">
                        <div className="leftWrapper_backBtn-Wrapper_text" id="backBtn" onClick={() => { this.handleBack() }}>Back</div>
                    </div>
                </div>
                <div className="rightWrapper">
                    <img className="settingsImg-wrapper" src="/assets/img/settingsBG.png" alt="" />
                </div>
                <div className="timedPopup" style={!this.state.errorPopup ? { opacity: '0' } : { opacity: '1' }} >{this.errorMessage}</div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    updateDevice: (deviceId, updateVal, value) => dispatch(updateDevice(deviceId, updateVal, value)),
    fetchDevice: (deviceId) => dispatch(fetchDevice(deviceId)),
    fetchSubscription: () => dispatch(fetchSubscription()),
});
export default connect((state) => {
    const { app, subscription, device } = state;
    return {
        app,
        subscription,
        device
    };
}, mapDispatchToProps)(Settings);
